import { getConfig } from '@cian/config/browser';
import { getHttpApi } from '@cian/http-api/browser';
import { getLogger } from '@cian/logger/browser';
import { IApplicationContext } from 'shared/types/applicationContext';
import { getTelemetry } from '@cian/telemetry/browser';
import { ICustomContextParams } from 'shared/types/ICustomContextParams';

export function createApplicationContext(): IApplicationContext {
  const config = getConfig();

  return {
    config,
    custom: config.getStrict<ICustomContextParams>('applicationContext.custom'),
    httpApi: getHttpApi(),
    logger: getLogger(),
    telemetry: getTelemetry(),
  };
}
